export default "__VITE_ASSET__BzkJkvf___"